// src/components/PageHeader.jsx
export default function PageHeader({ title, subtitle, children }) {
  return (
    <div className="lmd-page-header">
      <div className="lmd-page-header-row">
        <div>
          <h1 className="lmd-page-title">{title}</h1>
          {subtitle && <p className="lmd-page-subtitle">{subtitle}</p>}
        </div>
        {children && (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {children}
          </div>
        )}
      </div>
    </div>
  );
}
